import React from 'react';

import { Table, Label } from 'semantic-ui-react';

import { ContentSuggestionType } from 'components/modules/content/types/content-suggestion';
import { SIMPLE_DATE_FORMAT } from 'libs/date-utils/constants';
import DateUtils from 'libs/date-utils/date-utils';

import './ContentSuggestionInfoTable.scss';

const propTypes = {
  suggestion: ContentSuggestionType.isRequired,
};

function ContentSuggestionInfoTable({ suggestion }) {
  const { id, createdAt, keywords = [], explanation } = suggestion;

  return (
    <Table basic className="content-suggestion-info-table">
      <Table.Body>
        <Table.Row>
          <Table.Cell width={3}>ID</Table.Cell>
          <Table.Cell>{id}</Table.Cell>
        </Table.Row>

        <Table.Row>
          <Table.Cell width={3}>Suggested At</Table.Cell>
          <Table.Cell>{DateUtils.format(createdAt, SIMPLE_DATE_FORMAT)}</Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Targeted Keywords</Table.Cell>
          <Table.Cell>
            {keywords.map((keyword) => (
              <Label key={keyword}>{keyword}</Label>
            ))}
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>Explanation</Table.Cell>
          <Table.Cell>{explanation}</Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
}

ContentSuggestionInfoTable.propTypes = propTypes;

export default ContentSuggestionInfoTable;
